import React, { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import "../style/Contact.css";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Contact = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".ct-reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    emailjs
      .send(
        "service_dui89vd",
        "template_api2lht",
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
          message: formData.message,
        },
        "gj6mNHRnQwK9oX652"
      )
      .then(() => {
        setStatus(t("contact.success"));
        setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
      })
      .catch(() => {
        setStatus(t("contact.error"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <main className="ct-root">
      <Header />

      {/* ── HERO ───────────────────────────────────────── */}
      <section className="ct-hero">
        <div className="ct-hero__content">
          <div className="ct-hero__accent" />
          <span className="ct-eyebrow">{t("contact.heroEyebrow")}</span>
          <h1 className="ct-hero__title">{t("contact.heroTitle")}</h1>
          <p className="ct-hero__para">{t("contact.heroText")}</p>
        </div>
        <div className="ct-hero__scroll">
          <span className="ct-hero__scroll-line" />
        </div>
      </section>

      {/* ── CONTACT SECTION ────────────────────────────── */}
      <section className="ct-section">
        {/* INFO PANEL */}
        <div className="ct-info ct-reveal">
          <div className="ct-section-head">
            <span className="ct-eyebrow ct-eyebrow--dark">{t("contact.getInTouch")}</span>
            <h2 className="ct-section-title">{t("contact.infoTitle")}</h2>
          </div>
          <p className="ct-info__text">{t("contact.infoText")}</p>

          {[
            { label: t("contact.location"),     value: t("contact.locationValue") },
            { label: t("contact.email"),        value: "autopark.lennestadt@gmail.com" },
            { label: t("contact.phone"),        value: "+49 175 1932947" },
            { label: t("contact.workingHours"), value: t("contact.workingHoursValue") },
          ].map((box) => (
            <div className="ct-info-box" key={box.label}>
              <h3 className="ct-info-box__label">{box.label}</h3>
              <p className="ct-info-box__value">{box.value}</p>
            </div>
          ))}
        </div>

        {/* FORM */}
        <form className="ct-form ct-reveal" style={{ transitionDelay: "0.14s" }} onSubmit={sendEmail}>
          <div className="ct-form-row">
            <input
              type="text"
              name="name"
              placeholder={t("contact.fullName")}
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder={t("contact.emailAddress")}
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="ct-form-row">
            <input
              type="text"
              name="phone"
              placeholder={t("contact.phoneNumber")}
              value={formData.phone}
              onChange={handleChange}
            />
            <input
              type="text"
              name="subject"
              placeholder={t("contact.subject")}
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <textarea
            name="message"
            placeholder={t("contact.message")}
            rows="7"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <button type="submit" className="ct-submit" disabled={loading}>
            {loading ? t("contact.sending") : t("contact.sendMessage")}
          </button>
          {status && <p className="ct-status">{status}</p>}
        </form>
      </section>

      {/* ── MAP ────────────────────────────────────────── */}
      <section className="ct-map">
        <div className="ct-map__head ct-reveal">
          <div className="ct-section-head">
            <span className="ct-eyebrow ct-eyebrow--dark">{t("contact.findUs")}</span>
            <h2 className="ct-section-title">{t("contact.ourLocation")}</h2>
          </div>
        </div>
        <div className="ct-map__box ct-reveal" style={{ transitionDelay: "0.1s" }}>
          <iframe
            title={t("contact.mapTitle")}
            src="https://www.google.com/maps?q=Zur%20Christinenh%C3%BCtte%203,%2057368%20Lennestadt,%20Germany&output=embed"
            loading="lazy"
            allowFullScreen
          />
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default Contact;
